module.exports = new __parcel__URL__("cornershop-ipad.9e65c3b6.webp").toString();